<template>
  <Modal :id="'cmp_bookings_booking_add_artist'" @cancelled="onCancelClick">
    <template slot="header"> Batch Statements </template>
    <template slot="body">
      <div
        class="ut-flex"
        style="gap: 10px"
        :class="{
          'dt-loading': dataLoadingFlag,
        }"
      >
        <Dropdown
          deselect
          style="flex: 1"
          :options="statusTV"
          class="group-input m2"
          id="label_status_id"
          :placeholder="'Status'"
          :selected="statusTV.find((e) => e.value == label_status_id)"
          v-on:selectedChange="(e) => onDropdownChange('label_status_id', e)"
          box
          :listHeight="250"
        />
        <Dropdown
          deselect
          style="flex: 1"
          :options="invoiceProjectsTV"
          class="group-input m2"
          id="invoice_project_id"
          :placeholder="'Royalty Project'"
          :selected="
            invoiceProjectsTV.find((e) => e.value == invoice_project_id)
          "
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
          box
          :listHeight="250"
        />
      </div>
      <div
        class="ut-flex"
        style="gap: 10px"
        :class="{
          'dt-loading': dataLoadingFlag,
        }"
      >
        <Dropdown
          deselect
          style="flex: 1"
          :options="periodTypesTV"
          class="group-input m2"
          id="royalty_period"
          :placeholder="$t('period')"
          :selected="periodTypesTV.find((e) => e.value == royalty_period)"
          v-on:selectedChange="(e) => onDropdownChange('royalty_period', e)"
          box
          :listHeight="250"
        />
        <Dropdown
          style="flex: 1"
          :options="periodsTV"
          class="group-input m2"
          id="period"
          required
          showValidationIcons
          immediateValidation
          :placeholder="$t('statement_period')"
          :selected="periodsTV.find((e) => e.value == period)"
          v-on:selectedChange="(e) => onDropdownChange('period', e)"
          box
          :listHeight="250"
        />
      </div>
      <div
        class="ut-flex"
        style="gap: 10px"
        :class="{
          'dt-loading': dataLoadingFlag,
        }"
      >
        <Dropdown
          deselect
          style="flex: 1"
          :options="releasesTV"
          class="group-input m2"
          id="release_id"
          :placeholder="$t('release')"
          :selected="releasesTV.find((e) => e.value == release_id)"
          v-on:selectedChange="(e) => onDropdownChange('release_id', e)"
          box
          :listHeight="250"
        />
        <TextField
          style="flex: 1"
          class="m1"
          required
          :id="'statementYear'"
          v-bind="statementYearTFConfig"
          :value="statementYear"
          :placeholder="$t('statement_year')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        />
      </div>
      <div
        class="ut-flex"
        style="gap: 10px"
        :class="{
          'dt-loading': dataLoadingFlag,
        }"
      >
        <DTCheckbox
          style="flex: 1"
          :id="'create_credit_note'"
          :label="$t('create_credit_note')"
          :checked="create_credit_note"
          @click="(e) => onBatchStatementFlagClicked('create_credit_note', e)"
          :minH="'42px'"
          :class="'ml0'"
        />
        <DTCheckbox
          style="flex: 1"
          :id="'invoice_for_zero'"
          :label="'Cost Invoice also for 0.00 '"
          :checked="invoice_for_zero"
          @click="(e) => onBatchStatementFlagClicked('invoice_for_zero', e)"
          :minH="'42px'"
          :class="'ml0'"
        />
      </div>

      <SearchList
        :checkBoxPosition="'bottom'"
        :id="'artists'"
        :items="list"
        :keyProperty="'royalty_account_id'"
        :label="'royalty_account_name'"
        :placeholder="'Search Artists'"
        :selectionNumber="'multiple'"
        :isSearchable="false"
        @searched="onRoyaltySearched"
        @selected="onRoyaltySelected"
        :class="{
          'dt-loading': dataLoadingFlag,
        }"
      >
        <template v-slot:item="{ item }">
          <tr class="dt-table2--row" @click="(e) => onClickRow(e, item)">
            <td class="dt-table2--column checkbox-column">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="item.royalty_account_id"
                  :id="item.royalty_account_id"
                  :checked="selectedRoyalty.has(item.royalty_account_id)"
                  @click.stop="(e) => onCheckboxChange(e, item)"
                />
                <div class="checkmark"></div>
              </div>
              <!-- <div class="dt-table2--row">
                <div class="dt-table2--column checkbox-column">
                </div>
                <div class="txtov">
                  {{ item.royalty_account_name }}
                </div>
              </div> -->
            </td>
            <td class="dt-table2--column">
              <div class="txtov">
                {{ item.royalty_account_name }}
              </div>
            </td>
            <td class="dt-table2--column">
              <span class="txtov">{{ $t(getStatementStatus(item)) }}</span>
            </td>
          </tr>
        </template>
      </SearchList>
      <button
        class="dt-button v5 s8"
        @click="onSelectPending"
        :class="{
          disabled: pendingRoyaltyAccounts.length == 0 || isAllPendingSelected,
        }"
        :disabled="pendingRoyaltyAccounts.length == 0 || isAllPendingSelected"
        :title="
          pendingRoyaltyAccounts.length == 0
            ? $t('no_pending')
            : isAllPendingSelected
            ? $t('all_selected')
            : $t('select_pending')
        "
      >
        {{ $t("select_pending") }}
      </button>
    </template>
    <template slot="options">
      <button class="dt-button s7" @click="onCancelClick">Cancel</button>

      <button
        class="dt-button s7 v1"
        @click="onOKClicked"
        :class="{ disabled: !submitValidationResult }"
        :disabled="!submitValidationResult"
      >
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";

import { DTIconButton } from "../../../../plugins/button/button";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";

import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";

import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import SearchList from "../../../../dt-plugins/search-list/search-list.vue";

import { createTV, tv } from "../../../../models/text-value.model";

import { statementServices } from "../../services/statements/statements.service";

import { MHTTPCL } from "../../../../services/http/http-client";
import { AccountsService } from "../../services/accounts.service";
import {
  showError,
  showNotification,
} from "../../../../dt-plugins/notification/notification.service";
import { EventHooks } from "../../../../plugins/text-field";
import { confirmOK } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    Modal,
    NTable,
    InputField,
    DTIconButton,
    DTCheckbox,
    ModalContainer,
    SearchList,

    //AdvanceSearch,
  },
  mounted: async function () {
    this.dataLoadingFlag = true;
    const res = await statementServices.batchStatementFilter();
    // console.log("SHOP", res);
    this.dataLoadingFlag = false;

    this.royaltyAccountList = res.data.royalty_accounts;
    this.invoiceProjectList = res.data.invoice_projects;
    this.statusList = res.data.label_statuses;
    this.releasesList = res.data.all_releases;
    // this.digitalAccounts=res.data.digital_accounts;
    // this.physicalAccounts=res.data.physical_accounts;
  },
  data: function () {
    return {
      royaltyAccountList: [],
      selectedRoyalty: new Set(),
      invoiceProjectList: [],
      statusList: [],
      releasesList: [],
      invoice_project_id: "",
      label_status_id: "",
      royalty_period: "",
      release_id: "",
      statementYear: "",
      period: "",
      validationResult: {},

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      statementYearTFConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,

        valueChangedEvent: EventHooks.OnBlur,
        validationEvent: EventHooks.OnBlur,
      },

      activeStatusList: undefined,

      create_credit_note: false,
      invoice_for_zero: false,

      dataLoadingFlag: false,
      submitLoadingFlag: false,
    };
  },
  mixins: [
    // createLDTHost(LDTConfig),
    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
  ],

  computed: {
    list: function () {
      return this.royaltyAccountList;
    },
    invoiceProjectsTV: function () {
      return createTV(
        this.invoiceProjectList,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    statusTV: function () {
      return createTV(this.statusList, "label_status_name", "label_status_id");
    },
    periodTypesTV: function () {
      return [
        { text: this.$t("month"), value: 1 },
        { text: this.$t("quarter"), value: 3 },
        { text: this.$t("half_year"), value: 4 },
        { text: this.$t("year"), value: 5 },
      ];
    },
    periodsTV: function () {
      return [
        { period_type: 1, text: "M1", value: "M1" },
        { period_type: 1, text: "M2", value: "M2" },
        { period_type: 1, text: "M3", value: "M3" },
        { period_type: 1, text: "M4", value: "M4" },
        { period_type: 1, text: "M5", value: "M5" },
        { period_type: 1, text: "M6", value: "M6" },
        { period_type: 1, text: "M7", value: "M7" },
        { period_type: 1, text: "M8", value: "M8" },
        { period_type: 1, text: "M9", value: "M9" },
        { period_type: 1, text: "M10", value: "M10" },
        { period_type: 1, text: "M11", value: "M11" },
        { period_type: 1, text: "M12", value: "M12" },
        { value: "-" },
        { period_type: 3, text: "Q1", value: "Q1" },
        { period_type: 3, text: "Q2", value: "Q2" },
        { period_type: 3, text: "Q3", value: "Q3" },
        { period_type: 3, text: "Q4", value: "Q4" },
        { value: "-" },
        { period_type: 4, text: "S1", value: "S1" },
        { period_type: 4, text: "S2", value: "S2" },
        { value: "-" },
        { period_type: 5, text: "Y", value: "Y" },
      ]
        .filter((e) => {
          return this.royalty_period
            ? e.period_type == this.royalty_period
            : true;
        })
        .map(({ text, value }) => ({ text, value }));
    },
    releasesTV: function () {
      return createTV(this.releasesList, "release_artist", "release_id");
    },
    isFormValid: function () {
      return (
        Object.values(this.validationResult).every((e) => e.valid) &&
        !this.submitLoadingFlag
      );
    },
    submitValidationResult: function () {
      return this.isFormValid && this.selectedRoyalty?.size > 0;
    },

    periodOrDefault() {
      return (
        (
          this.periodsTV?.find((e) => e.value == this.period) ||
          this.periodsTV?.[0]
        )?.value || ""
      );
    },
    pendingRoyaltyAccounts() {
      return this.royaltyAccountList
        .filter((e) => this.getStatementStatus(e) == "pending")
        .map((e) => e.royalty_account_id);
    },
    isAllPendingSelected() {
      // console.log(
      //   this.pendingRoyaltyAccounts,
      //   this.pendingRoyaltyAccounts.filter((e) => !this.selectedRoyalty.has(e))
      // );
      return (
        this.pendingRoyaltyAccounts.filter((e) => !this.selectedRoyalty.has(e))
          .length == 0
      );
    },
  },
  methods: {
    closeModal: function () {
      closeModalRoute(this);
    },
    onCheckboxChange: function (event, item) {
      this.selectedRoyalty = addRemoveSet(
        event.target.checked,
        this.selectedRoyalty,
        item.royalty_account_id
      );
    },

    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onRoyaltySearched: function () {},
    onDropdownChange: async function (key, value) {
      this[key] = value.value;

      if (key === 'royalty_period') {
        if (!this.periodsTV.find((e) => e.value === this.period)) {
          this.period = this.periodsTV[0].value;
        }
      }

      this.dataLoadingFlag = true;
      const res = await statementServices.searchBatchAccounts(
        this.label_status_id,
        this.invoice_project_id,
        this.royalty_period,
        this.release_id
      );
      this.royaltyAccountList = res.data.royalty_accounts;
      this.dataLoadingFlag = false;

      if (key == "period" && this.statementYear && this.period) {
        this.fetchActiveStatusList();
      }
    },
    onRoyaltySelected: function (selectedRoyalty) {
      this.selectedRoyalty = selectedRoyalty;
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextFieldValueChange: async function (name, value) {
      this[name] = value;

      if (name == "statementYear" && +this.statementYear > 0) {
        // First month and date of the year this.statementYear
        this.fetchActiveStatusList();
      }
    },
    isLeapYear:function (year) {
      return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    },
    getStartAndEndDate(period, year) {
      let start_date, end_date;

      switch (period) {
        case "M1":
          start_date = `${year}-01-01`;
          end_date = `${year}-01-31`;
          break;
        case "M2":
          start_date = `${year}-02-01`;
          end_date = this.isLeapYear(this.statementYear)? `${year}-02-29`:`${year}-02-28`;
          break;
        case "M3":
          start_date = `${year}-03-01`;
          end_date = `${year}-03-31`;
          break;
        case "M4":
          start_date = `${year}-04-01`;
          end_date = `${year}-04-30`;
          break;
        case "M5":
          start_date = `${year}-05-01`;
          end_date = `${year}-05-31`;
          break;
        case "M6":
          start_date = `${year}-06-01`;
          end_date = `${year}-06-30`;
          break;
        case "M7":
          start_date = `${year}-07-01`;
          end_date = `${year}-07-31`;
          break;
        case "M8":
          start_date = `${year}-08-01`;
          end_date = `${year}-08-31`;
          break;
        case "M9":
          start_date = `${year}-09-01`;
          end_date = `${year}-09-30`;
          break;
        case "M10":
          start_date = `${year}-10-01`;
          end_date = `${year}-10-31`;
          break;
        case "M11":
          start_date = `${year}-11-01`;
          end_date = `${year}-11-30`;
          break;
        case "M12":
          start_date = `${year}-12-01`;
          end_date = `${year}-12-31`;
          break;
        case "Q1":
          start_date = `${year}-01-01`;
          end_date = `${year}-03-31`;
          break;
        case "Q2":
          start_date = `${year}-04-01`;
          end_date = `${year}-06-30`;
          break;
        case "Q3":
          start_date = `${year}-07-01`;
          end_date = `${year}-09-30`;
          break;
        case "Q4":
          start_date = `${year}-10-01`;
          end_date = `${year}-12-31`;
          break;
        case "S1":
          start_date = `${year}-01-01`;
          end_date = `${year}-06-30`;
          break;
        case "S2":
          start_date = `${year}-07-01`;
          end_date = `${year}-12-31`;
          break;
        case "Y":
          start_date = `${year}-01-01`;
          end_date = `${year}-12-31`;
          break;
        default:
          start_date = `${year}-01-01`;
          end_date = `${year}-12-31`;
      }

      return { start_date, end_date };
    },
    fetchActiveStatusList: async function () {
      // const start_date = this.statementYear + "-01-01";
      // const end_date = this.statementYear + "-01-31";
      if (!this.statementYear) {
        return;
      }
      const { start_date, end_date } = this.getStartAndEndDate(
        this.periodOrDefault,
        this.statementYear
      );

      this.dataLoadingFlag = true;
      this.activeStatusList = await statementServices
        .get_statements_status(start_date, end_date)
        .then((res) => res.data);
      this.dataLoadingFlag = false;
    },
    getStatementStatus(royalty_account) {
      return this.activeStatusList
        ? this.activeStatusList.royalty_accounts?.includes(
            royalty_account.royalty_account_id
          )
          ? "already_calculated"
          : "pending"
        : "";
    },
    onBatchStatementFlagClicked: function (name, event) {
      // console.log({ "batch-statement-modal.vue:482 name, event": name, event });
      this[name] = event.target.checked;
    },
    onOKClicked: async function () {
      if (!this.periodOrDefault || !this.statementYear) {
        return;
      }
      this.submitLoadingFlag = true;
      const { start_date, end_date } = this.getStartAndEndDate(
        this.period,
        this.statementYear
      );
      const check_royalty_dates = await AccountsService.checkStatementDate({
        start_date,
        end_date,
      });

      if (check_royalty_dates?.status == 1) {
        await statementServices.create_batch_statements({
          year: this.statementYear,
          period: this.period,
          start_date,
          end_date,
          royalty_accounts: [
            ...Array.from(this.selectedRoyalty).map((e) => `${e}`),
          ],
          invoice: this.create_credit_note ? 1 : 0,
          zero_credit_note: this.invoice_for_zero ? 1 : 0,
        });
        this.submitLoadingFlag = false;

        // showNotification(this.$t("notify_process_complete"));

        confirmOK(this.$t("notify_process_complete"));

        this.$emit("cancelled", true);
        return;
      } else {
        showError(this.$t("error"));
        this.submitLoadingFlag = false;
        return;
      }
    },
    onBatchFormValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onClickRow(e, item) {
      this.selectedRoyalty = addRemoveSet(
        "toggle",
        this.selectedRoyalty,
        item.royalty_account_id
      );
      // console.log({
      //   "batch-statement-modal.vue:591 this.selectedRoyalty":
      //     this.selectedRoyalty,
      // });
    },
    onSelectPending() {
      // console.log({
      //   "batch-statement-modal.vue:604 this.selectedRoyalty":
      //     this.selectedRoyalty,
      // });
      this.selectedRoyalty = new Set(
        this.royaltyAccountList
          .filter((e) => this.getStatementStatus(e) == "pending")
          .map((e) => e.royalty_account_id)
      );
      // console.log({
      //   "batch-statement-modal.vue:604 this.selectedRoyalty":
      //     this.selectedRoyalty,
      // });
    },
    //MARK: Methods
  },
};
</script>


<style lang="scss">
.cmp_bookings_booking_add_artist {
  .select-all-row {
    margin-left: 3px !important;
    .select-all-checkbox {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
}
</style>